<template>
  <div class="moments-item" :class="{ 'moments-item_active': active }">
    <div class="moments-item-header" @click="$emit('changeSlide')">
      <span class="moments-item-header__text">{{ result.printName }}</span>
      <svg
        v-if="!active"
        class="moments-item-header__icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.8333 10.8317H10.8333V15.8317H9.16663V10.8317H4.16663V9.16504H9.16663V4.16504H10.8333V9.16504H15.8333V10.8317Z"
          fill="white"
        />
      </svg>
    </div>
    <a v-if="screenWidth >= 768" :href="result.detailPage" class="moments-item-main">
      <DefPicture :result="result.pictures" :max-width="imgWidth" />
    </a>
    <SlideUpDown v-else :model-value="active">
      <a :href="result.detailPage" class="moments-item-main">
        <DefPicture :result="result.pictures" />
      </a>
    </SlideUpDown>
  </div>
</template>

<script lang="ts" setup>
import { IMomentsItem } from '@components/Moments/IMoments';
import { screenWidth } from '@use/useDeviceInfo';
import SlideUpDown from 'vue3-slide-up-down';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';

const props = defineProps<{
  result: IMomentsItem;
  active: boolean;
  imgWidth: string;
  imgHeight: string;
}>();

const { tagColor } = props.result;
</script>

<style lang="scss" scoped>
.moments-item {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: 0.5s linear width;
  @include point-md {
    flex-direction: row;
    width: 50px;
    min-width: 50px;
  }
  @include point-lg {
    width: 70px;
    min-width: 70px;
  }
  &_active {
    @include point-md {
      width: 100%;
    }
  }
  :deep(.def-picture__image) {
    @include point-md {
      width: v-bind(imgWidth);
    }
  }
}
.moments-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  min-height: 48px;
  background-color: v-bind(tagColor);
  cursor: pointer;
  z-index: 1;
  @include point-md {
    min-height: unset;
    width: 50px;
    writing-mode: vertical-rl;
    padding: 24px 0;
    transform: rotate(180deg);
    flex-shrink: 0;
  }
  @include point-lg {
    width: 70px;
  }
  &__text {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 1.44px;
    text-transform: uppercase;
  }
  &__icon {
    width: 20px;
    height: 20px;
  }
}
.moments-item-main {
  display: block;
  flex-grow: 1;

  @include point-md {
    max-width: calc(100% - 70px);
  }
}
</style>
